import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { FolderItemFilterModel } from "../models";

@Injectable({ providedIn: 'root' })

export class FolderService {
    private apiBaseUrl = environment.apiBaseUrl + 'api/folder';

    constructor(private http: HttpClient) { }

    getSelectListItems(groupId?: number, id?: number): Observable<any> {
        if (groupId == undefined) {
            groupId = null;
        }
        if (id == undefined) {
            id = null;
        }
        
        return this.http.get(`${this.apiBaseUrl}/get-select-list-items/${groupId}/${id}`);
    }

    getListItems(model: FolderItemFilterModel) {
        return this.http.get(`${this.apiBaseUrl}/list-items?` + model.toQueryString());
    }
   
    delete(id: number) {
        return this.http.post(this.apiBaseUrl + '/delete/' + id, null);
    }
}